import en from './langs/en.json';
import sk from './langs/sk.json';

export const messages = {
  sk,
  en,
};
